<template>
  <confirm-action-dialog
    :title="$t('components.LanguageDialog.title')"
    :subtitle="$t('components.LanguageDialog.subtitle')"
    :hide-close="true"
    :hide-left="true"
    :isDialogActive="value"
    persistent
    @rightClick="emitNext"
    @close="emitNext"
  >
    <debug :debug="browserLanguage"></debug>
    <v-autocomplete
      v-model="local"
      :items="items"
      item-text="text"
      outlined
      v-if="value"
      :label="$t('components.LanguageDialog.title')"
    >
      <template v-slot:selection="data">
        <span>{{ data.item.value | getFlagEmojiByLanguage }}</span>
        <span class="pl-4">{{ $t(`enums.LanguageCodeEnum.${data.item.value}`) }}</span>
      </template>
      <template v-slot:item="data">
        <v-list-item-avatar>
          {{ data.item.value | getFlagEmojiByLanguage }}
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{ $t(`enums.LanguageCodeEnum.${data.item.value}`) }}</v-list-item-title>
        </v-list-item-content>
      </template>
    </v-autocomplete>
  </confirm-action-dialog>
</template>

<script lang="ts">
import { getFlagEmojiByLanguage } from "@/lib/CountryCodeHelper";
import { LanguageCodeEnum } from "@/lib/enum/language-code.enum";
import DarkModeHighlightMixin from "@/mixins/DarkModeHighlightMixin.vue";
import { ConfigModule } from "@/store/modules/config";
import { Component, Prop } from "vue-property-decorator";
import ConfirmActionDialog from "./ConfirmActionDialog.vue";
import Debug from "./Debug.vue";

interface ILanguageAutocomplete {
  text: string;
  value: string;
}

@Component({
  components: { ConfirmActionDialog, Debug },
  filters: { getFlagEmojiByLanguage }
})
export default class LanguageDialog extends DarkModeHighlightMixin {
  @Prop()
  value!: boolean;

  get local() {
    return ConfigModule.locale ?? (this.$i18n.locale as LanguageCodeEnum);
  }

  set local(locale: LanguageCodeEnum) {
    ConfigModule.setLocale(locale);
  }

  get locals() {
    return ConfigModule.availableLanguages;
  }

  /** Languages hidden from the picker (still available via query parameter) */
  hiddenLanguages: LanguageCodeEnum[] = [];

  get items(): ILanguageAutocomplete[] {
    return this.locals
      .filter((l) => !this.hiddenLanguages.includes(l))
      .map((l) => ({
        value: l,
        text: this.$t(`enums.LanguageCodeEnum.${l}`).toString()
      }));
  }

  get browserLanguage() {
    return navigator.language || (navigator as any).userLanguage;
  }

  emitNext() {
    this.$emit("next", this.local);
  }
}
</script>

<style></style>
